import { isNotNullOrUndefined, isStringNotEmpty } from "../../utils/objectUtils";

const IconButton = ({ icon, size = null, title, style = {}, type = "button", variant, onClick, disabled = false, className = null, ...otherProps }) => {

    let classes = ['btn'];
    if (isNotNullOrUndefined(size)) {
        classes.push(`btn-${size}`);
    }
    if (isNotNullOrUndefined(variant)) {
        classes.push(`btn-${variant}`);
    }

    let additionalProps = {};
    if (isNotNullOrUndefined(onClick)) {
        additionalProps.onClick = onClick;
    }

    if (isStringNotEmpty(title)) {
        return (
            <button type={type} disabled={disabled} {...additionalProps} style={style} className={classes.join(' ') + (isStringNotEmpty(className) ? ' ' + className : '')} data-toggle="tooltip" data-placement="top" aria-label={title ? title : 'button'} title={title} {...otherProps}>
                {icon}
            </button>
        );
    } else {
        return (
            <button type={type} disabled={disabled} {...additionalProps} style={style} className={classes.join(' ') + (isStringNotEmpty(className) ? ' ' + className : '')} {...otherProps}>
                {icon}
            </button>
        );
    }
};

export default IconButton;